"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataPlaneClient = exports.ControlPlaneClient = exports.Client = void 0;
const fetch_1 = require("./fetch");
const nativeFetch = globalThis.fetch;
class Client {
    constructor({ fetch = nativeFetch, middleware = Client.middleware, } = {}) {
        this.baseFetch = (0, fetch_1.applyFetchMiddleware)(middleware, fetch);
    }
    fetch(...args) {
        return this.baseFetch(...args);
    }
}
exports.Client = Client;
Client.middleware = [fetch_1.corsMiddleware, fetch_1.apiErrorMiddleware];
class ControlPlaneClient {
    static buildMiddleware(getAccessToken) {
        return [(0, fetch_1.authMiddleware)(getAccessToken), ...Client.middleware];
    }
    constructor({ getAccessToken, fetch = nativeFetch, middleware = ControlPlaneClient.buildMiddleware(getAccessToken), }) {
        this.baseClient = new Client({
            fetch,
            middleware,
        });
    }
    fetch(...args) {
        return this.baseClient.fetch(...args);
    }
}
exports.ControlPlaneClient = ControlPlaneClient;
class DataPlaneClient {
    static buildMiddleware() {
        return Client.middleware.slice();
    }
    constructor({ host, scheme = host.startsWith("localhost") ? "http" : "https", fetch = nativeFetch, middleware = DataPlaneClient.buildMiddleware(), }) {
        this.host = host;
        this.scheme = scheme;
        this.baseClient = new Client({
            fetch,
            middleware,
        });
    }
    fetch(...args) {
        // If the caller passes only a path, build a full URL from
        // the scheme & host provided to the constructor.
        if (typeof args[0] === "string" && args[0][0] === "/") {
            args[0] = `${this.scheme}://${this.host}${args[0]}`;
        }
        return this.baseClient.fetch(...args);
    }
}
exports.DataPlaneClient = DataPlaneClient;
